import React from 'react';

export interface FeatureFlagsIntegratorFlag {
  readonly integrators: readonly string[]; // Use ['*'] to enable for all integrators
}

export type FeatureFlagsFlagValue = boolean | FeatureFlagsIntegratorFlag;

export interface FeatureFlagsContextType {
  getFlag(flagKey: string, defaultValue?: FeatureFlagsFlagValue): FeatureFlagsFlagValue;
}

export interface FeatureFlagsUserContext {
  readonly key?: string;
  readonly email?: string;
  readonly name?: string;
  readonly integratorId?: string;

  readonly [key: string]: any;
}

export const FeatureFlagsContext = React.createContext<FeatureFlagsContextType | undefined>(
  undefined,
);

export const isIntegratorsFeatureFlag = (
  flag: FeatureFlagsFlagValue,
): flag is FeatureFlagsIntegratorFlag =>
  typeof flag === 'object' && flag !== null && 'integrators' in flag;
